import { useQuery } from "@tanstack/react-query";
import { API_CITIES } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchCities = () => {
  return useQuery({
    queryKey: ["cities"],
    queryFn: () => fetcher(API_CITIES),
    select: (response) =>
      Array.isArray(response?.data) ? [...response.data].reverse() : [],
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
